let PER_PAGE = 9;

let grid: HTMLElement | null = null;
let cards: HTMLElement[] = [];
let btnMore: HTMLButtonElement | null = null;
let filterLocation: HTMLInputElement | null = null;
let btnClear: HTMLButtonElement | null = null;

let activeLocationNorm: string | null = null;
let shown = 0;

function norm(s: string) {
	return s.trim().toLocaleLowerCase("hu-HU");
}

function getFilteredCards(): HTMLElement[] {
	if (!activeLocationNorm) return cards;

	return cards.filter((c) => {
		const locs = c.dataset.locations ?? "";
		return locs.split("|").some((loc) => norm(loc).includes(activeLocationNorm!));
	});
}

function applyVisibility() {
	for (const c of cards) c.classList.add("hidden");

	const filtered = getFilteredCards();
	const next = Math.min(PER_PAGE, filtered.length);

	for (let i = 0; i < next; i++) filtered[i].classList.remove("hidden");
	shown = next;

	if (btnMore) {
		btnMore.classList.toggle("hidden", shown >= filtered.length);
	}
}

function loadMore() {
	const filtered = getFilteredCards();
	const next = Math.min(shown + PER_PAGE, filtered.length);

	for (let i = shown; i < next; i++) filtered[i].classList.remove("hidden");
	shown = next;

	if (btnMore) btnMore.classList.toggle("hidden", shown >= filtered.length);
}

function setLocationFilter(location: string | null) {
	activeLocationNorm = location ? norm(location) : null;
	applyVisibility();
}

export function initAttendants(opts: { perPage: number }) {
	PER_PAGE = opts.perPage;

	grid = document.getElementById("attendants-grid");
	if (!grid) return;

	cards = Array.from(grid.querySelectorAll<HTMLElement>(".att-card"));
	btnMore = document.getElementById("load-more-attendants") as HTMLButtonElement | null;
	filterLocation = document.getElementById("att-location") as HTMLInputElement | null;
	btnClear = document.getElementById("att-clear") as HTMLButtonElement | null;

	btnMore?.addEventListener("click", loadMore);

	filterLocation?.addEventListener("input", () => {
		const val = filterLocation?.value ?? "";
		setLocationFilter(val || null);
	});

	btnClear?.addEventListener("click", () => {
		if (filterLocation) filterLocation.value = "";
		setLocationFilter(null);
	});

	applyVisibility();
}
